import { useStore } from "@/store";
import { flashWarning } from "@/utils";

export const fetchOperationskoder = async ({ query }: { query?: string; is_valid_now?: boolean } = {}) => {
    const store = useStore();

    try {
        const params: { q?: string; is_valid_now?: boolean } = {};

        if (query) {
            params.q = query;
        }
        params.is_valid_now = true;

        const { subsetName } = await store.dispatch("operation/operationskod/fetchOperationskoder", {
            filterParams: params,
            displayMode: true,
        });

        return store.getters["operation/operationskod/operationskodSubset"]({ subsetName, displayMode: true });
    } catch (error) {
        flashWarning("Kunde inte hämta operationskoder");
    }
};
